import { useTranslation } from 'react-i18next';

import { Box, forwardRef, IconButton, MenuOutline, rem, Tooltip, XOutline } from '@bonusly/design-system';

import { useCurrentUser } from '../../../../lib/who-am-i';
import { UserAvatar } from '../User';

interface NavMenuButtonProps {
	isMobile: boolean;
	isOpen: boolean;
	onClick: VoidFunction;
}

export const NavMenuButton = forwardRef<NavMenuButtonProps, 'button'>(({ isMobile, isOpen, onClick }, ref) => {
	const { t } = useTranslation(['navigation', 'common']);
	const user = useCurrentUser();

	const ariaLabel = isOpen ? t('common:close') : t('navigation:user_menu.account_menu');

	if (isMobile) {
		return (
			<Box ref={ref}>
				<IconButton
					_active={{ transform: 'scale(0.95)' }}
					aria-label={ariaLabel}
					backgroundColor="gray.50"
					borderRadius="full"
					color="gray.900"
					fontSize="lg"
					height={rem(40)}
					icon={isOpen ? <XOutline size="sm" /> : <MenuOutline size="sm" />}
					id="primary-nav-profile"
					onClick={onClick}
					transitionDuration="normal"
					transitionProperty="common"
				/>
			</Box>
		);
	}

	return (
		<Box ref={ref}>
			<Tooltip label={t('navigation:user_menu.menu_label')} placement="bottom-start">
				<Box
					id="primary-nav-profile"
					_active={{ transform: 'scale(0.95)' }}
					as="button"
					onClick={onClick}
					transitionDuration="normal"
					transitionProperty="common"
					aria-label={ariaLabel}
					display="flex"
					alignItems="center"
				>
					<UserAvatar border="none" boxSize={rem(44)} cursor="pointer" size="lg" user={user} />
				</Box>
			</Tooltip>
		</Box>
	);
});
